module.exports = __webpack_public_path__ + "img/32.44a26ac2.jpg";